import { Language } from 'apollo/localizedTypes';
import * as texts from 'assets/texts/localizedText';

const languageLabels: Record<Language, string> = {
  es: texts.spanish,
  en: texts.english,
};

export default languageLabels;
